import { createApp, configureCompat } from 'vue'
import App from './App.vue'



/** Plugins, configs & utils */

import '@/plugins/validations'
import '@/configs/debug'

/** 3rd Party Packages */
import VuePlyr from 'vue-plyr'

// Mixins


/** Other */
import 'es6-promise/auto'

/** CSS */
import '../node_modules/@fortawesome/fontawesome-free/css/all.css'
import '@/assets/css/main.css'
import '@/assets/css/lets.css'
import '../node_modules/vue-plyr/dist/vue-plyr.css'

import { register } from 'swiper/element/bundle'

register()

const app = createApp(App);
import router from './router'
app.use(router)

import store from './store'
import { cloneDeep } from 'lodash'
app.use(store)
const initialStateCopy = cloneDeep(store.state)
// Function for reset state to initial state
app.config.globalProperties.$resetState = () => {
  const initialState = cloneDeep(initialStateCopy)
  initialState.Auth.init = store.state.Auth.init
  store.replaceState(initialState)
}

// reset target module state
app.config.globalProperties.$resetStoreState = (module) => {
  if (store.state[module] === undefined) {
    throw new Error(`Module '${module}' does not exist in store`)
  }
  console.warn(`Resetting store state for module: ${module}`)
  store.state[module] = cloneDeep(initialStateCopy[module])
  // store.replaceState(store.state)
}

import vuetify from '@/plugins/vuetify'
app.use(vuetify)

import i18n from '@/plugins/i18n'
app.use(i18n)

import directives from '@/plugins/directives'
app.use(directives)

import FullScreenLoading from '@/plugins/FullScreenLoading/FullScreenLoading.js'
app.use(FullScreenLoading, { vuetify }) // $fullScreenLoading

import toastify from './plugins/toastify'
app.use(toastify) // $toast

import NProgress from './plugins/nProgressPlugin'
app.use(NProgress) // $NProgress

import SetStatePlugin from '@/plugins/setStatePlugin'
app.use(SetStatePlugin) // $setState

import moment from './plugins/moment'
app.use(moment) // $moment

import DialogPlugin from './plugins/DialogPlugin'
app.use(DialogPlugin, { vuetify }) // $confirm

import DialogManagerPlugin from './plugins/DialogManagerPlugin'
app.use(DialogManagerPlugin) // $dialogManager

import ApiPlugin from '@/plugins/ApiPlugin/ApiPlugin.js'
app.use(ApiPlugin) // $api

import StatePreservationPlugin from './plugins/StatePreservationPlugin'
app.use(StatePreservationPlugin) // $StatePreservation_preserveStateOnMount

import ApiIntervalPollingPlugin from './plugins/ApiIntervalPollingPlugin'
app.use(ApiIntervalPollingPlugin) // $apiIntervalPolling

app.use(VuePlyr)

/** Configuration */
if (import.meta.env.VITE_API_SELF_DOMAIN_ENABLED === 'true') {
  let port = '/'
  if (import.meta.env.VITE_API_PORT !== undefined && import.meta.env.VITE_API_PORT !== '') {
    port = `:${import.meta.env.VITE_API_PORT}/`
  }
  const domain = '//' + window.location.hostname + port
  app.config.globalProperties.$API_URL = domain
  window.API_URL = domain
} else {
  app.config.globalProperties.$API_URL = import.meta.env.VITE_API_URL
  window.API_URL = import.meta.env.VITE_API_URL
}
app.config.performance = true

// https://vee-validate.logaretm.com/v4/api/form/
import { Form } from 'vee-validate'
app.component('VeeForm', Form)

// GLobal Mixins Registrations
import AppMixin from '@/mixins/global/app'
app.mixin(AppMixin)
import BrowserBackProtectionMixin from '@/mixins/global/BrowserBackProtectionMixin'
app.mixin(BrowserBackProtectionMixin)

app.config.compilerOptions.isCustomElement = (tag) => {
  return tag.startsWith('trix-')
}


// disable compat for certain features
configureCompat({
  MODE: 3,
  COMPONENT_ASYNC:false,
})

app.mount("#app");

// @deprecated global references
window.vue = app
window.vue.$router = router
window.vue.$store = store
window.vue.$i18n = i18n
window.vue.$i18n.t = i18n.global.t.bind(i18n.global)
window.vue.$dialog = {}
window.vue.$dialog.notify = app.config.globalProperties.$toast
app.config.globalProperties.$dialog = {}
app.config.globalProperties.$dialog.notify = app.config.globalProperties.$toast
window.vue.$confirm = app.config.globalProperties.$confirm
window.vue.$vuetify = vuetify
app.config.globalProperties.$vuetify = vuetify

window.$this = app.config.globalProperties
